<template>
  <div class="form-wrapper">
    <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css" />
    <!-- <div class="form-message">
      <h2>Ready To Work With Us?</h2>
      <p class="form-subhead">
        Please fill out this form and a representative from GBS will respond as
        soon as possible.
      </p>
    </div> -->

    <form id="contact" @submit.prevent="submitToAPI(from_name, from_message, from_email, from_phone)">
      <h2 class="form-title">Contact Form</h2>
      <p> Ready To Work With Us? Please fill out this form and a representative from GBS will respond as
        soon as possible.</p>
      <div class="form-group">
        <input type="text" v-model="from_name" placeholder="Name" class="form-control"
          :class="{ 'is-invalid': submitted && $v.from_name.$error }" />
        <div v-if="submitted && !$v.from_name.required" class="invalid-feedback">Your name is required</div>
      </div>
      <div class="form-group">
        <input type="email" v-model="from_email" placeholder="Email" name="email" class="form-control"
          :class="{ 'is-invalid': submitted && $v.from_email.$error }" />
        <div v-if="submitted && $v.from_email.$error" class="invalid-feedback"> A valid email address is required
        </div>
      </div>
      <div class="form-group">
        <input type="tel" v-model="from_phone" placeholder="Phone Number (ex. 555-555-5555)" name="phone" class="form-control"
          :class="{ 'is-invalid': submitted && $v.from_phone.$error }" />
        <div v-if="submitted && $v.from_phone.$error" class="invalid-feedback">A valid phone number is required
        </div>
      </div>
      <div class="form-group">
        <textarea v-model="from_message" placeholder="Quick Project Description" name="message" class="form-control"
          :class="{ 'is-invalid': submitted && $v.from_message.$error }"> </textarea>
        <div v-if="submitted && $v.from_message.$error" class="invalid-feedback"> A quick description of your project is required
        </div>
      </div>
      <div class="form-group">
        <b-button v-if="!submittedSuccess" id="submit-order-button" class="button" type="submit">Submit
        </b-button>
        <b-button v-else disabled id="success-button" class="button">Success!
        </b-button>
      </div>
    </form>
  </div>
</template>
<script>

import axios from 'axios';
import { required, email } from 'vuelidate/lib/validators'

export default {
  name: "ContactForm",
  data() {
    return {
      from_name: "",
      from_phone: "",
      from_email: "",
      from_message: "",
      submitted: false,
      submittedSuccess: false
    };
  },
  validations: {
    from_name: {
      required
    },
    from_phone: {
      required
    },
    from_email: {
      required,
      email
    },
    from_message: {
      required
    },
  },
  created() {
    this.$v.$reset()
  },
  methods: {
    async submitToAPI(name, message, email, phone) {
      var URL = "https://tksgebs3bi.execute-api.us-east-1.amazonaws.com/prod/godfreycontactform";
      this.submitted = true;

      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }

      var data = {
        name: name,
        phone: phone,
        email: email,
        message: message,
      };

      console.log("data:", data)
      const response = await axios.post(URL, data);
      console.log(response);

      this.resetForm()

    },
    resetForm() {
      this.from_name = "";
      this.from_email = "";
      this.from_phone = "";
      this.from_message = "";
      this.$v.$reset;


      this.submitted = false;
      this.submittedSuccess = true;
    }
  },
};
</script>
<style scoped>
* {
  color: #33404d;
}

.form-wrapper {
  width: 70%;
  margin: 0 auto;
}

#submit-order-button {
  background-color: #33404d;
  font-weight: bold;
  width: 7rem;
  margin: 10px 0;
}

.form-title {
  color: #33404d;
  font-weight: bold;
  margin: 20px 0;
}
.form-message {
  float: left;
  width: 50%;
  text-align: left;
  padding: 25px;
}

.form-message h2 {
  color: #33404d;
  font-weight: bold;
}

.form-subhead {
  margin-top: 1rem;
  margin-bottom: 1rem;
}

#contact {
  padding: 25px;
  width: 50%;
  margin: 0 auto;
}

#contact input[type="text"],
#contact input[type="email"],
#contact input[type="tel"],
#contact input[type="url"],
#contact input[type="date"],
#contact textarea {
  width: 100%;
  border: 1px solid #ccc;
  background: #fff;
  margin: 0 0 5px;
  padding: 10px;
}

#contact textarea {
  height: 100px;
  max-width: 100%;
  resize: none;
}

.social-media {
  text-align: center;
  padding: 25px;
}

.fa {
  padding: 10px;
  text-decoration: none;
  margin: 0 20px;
  border-radius: 40%;
}

.invalid {
  border: 5px solid red;
}


.fa:hover {
  opacity: 0.7;
}

.fa-facebook {
  background: #3b5998;
  color: white;
}

.fa-twitter {
  background: #55acee;
  color: white;
}

.fa-linkedin {
  background: #007bb5;
  color: white;
}

.fa-instagram {
  background: #125688;
  color: white;
}

#success-button {
  background-color: green;
}

@media only screen and (max-width: 500px) {

  .form-message {
    float: none;
    width: 100%;
    text-align: center;
    padding: 20px;
  }

  #contact {
    padding: 0px;
    width: 100%;
    float: none;
  }
}
</style>